import React, { useEffect, useState } from 'react'
import groupApi from '_api/group'
import GroupMap from '_components/GroupMap/GroupMap'
import useFindGroupJoin from './useFindGroupJoin'
import './style.scss'

const searchMapGroups = (keyword) =>
  groupApi.searchGroupsMap(keyword).then((res) => res?.msgResp || [])

// group id -> UserGroup approval of the current user (1: pending, 2: member)
const toApprovalByGroupId = (groups = []) =>
  groups.reduce((acc, group) => ({ ...acc, [group.gid]: group.approval }), {})

const FindGroup = () => {
  const [groups, setGroups] = useState([])
  const [approvalByGroupId, setApprovalByGroupId] = useState({})

  const loadMembership = async () => {
    const res = await groupApi.getGroupWithUser()
    const approvals = toApprovalByGroupId(res?.msgResp?.groups)
    setApprovalByGroupId(approvals)
    return approvals
  }

  const { getAction, questionTarget, answer, setAnswer, submitAnswer, closeQuestion } =
    useFindGroupJoin({ approvalByGroupId, loadMembership })

  useEffect(() => {
    groupApi
      .getListGroupsMap()
      .then((res) => setGroups(res?.msgResp || []))
      // The map still renders the island without pins if the list can't be loaded
      .catch(() => setGroups([]))
    loadMembership().catch(() => {})
  }, [])

  return (
    <div className='find-group-page'>
      <div className='find-group-page__header'>
        <h1 className='find-group-page__title'>Find hosts near you</h1>
        <p className='find-group-page__sub'>
          Search a postal code or neighbourhood to see group buys happening close to you, then tap a
          pin to join.
        </p>
      </div>

      <GroupMap groups={groups} getAction={getAction} searchGroups={searchMapGroups} showHostList />

      {questionTarget && (
        <div className='find-group-question' role='dialog' aria-modal='true'>
          <div className='find-group-question__modal'>
            <div className='find-group-question__title'>One quick question</div>
            <div className='find-group-question__sub'>{questionTarget.question}</div>
            <textarea
              className='find-group-question__answer'
              placeholder='Type your answer...'
              value={answer}
              onChange={(event) => setAnswer(event.target.value)}
              autoFocus
            />
            <div className='find-group-question__actions'>
              <button type='button' className='find-group-question__cancel' onClick={closeQuestion}>
                Cancel
              </button>
              <button type='button' className='find-group-question__submit' onClick={submitAnswer}>
                Submit request
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default FindGroup
